import React, { useState, useEffect } from 'react';
import './GallerySlider.css';

const GallerySlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [scaleValue, setScaleValue] = useState(1);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const slides = [
    {
      id: 1,
      image: '/img/birte_2.jpg',
      tag: 'Video Production & Visual Concept',
      title: 'The Wild Path - Breathwork by Birte Peters',
      subtitle: 'Breathe. Release. Transform. Together with Birte, we translated the intensity of her breathwork sessions into moving images.',
      projectImage: '/img/birte_4.jpg',
      projectText: 'Watch Video',
      projectLink: 'https://www.youtube.com/watch?v=CETQqoOC6Ck&t=42s'
    },
    {
      id: 2,
      image: '/img/julian_5.jpg',
      tag: 'Platform Development & Branding',
      title: 'BonusClub AI WebStudio',
      subtitle: 'From vision to platform: An AI-powered solution that enables entrepreneurs to launch professional websites in record time.',
      projectImage: '/img/guest_pages.jpg',
      projectText: 'Visit Website',
      projectLink: 'https://bonusclub.io'
    },
    {
      id: 4,
      image: '/img/aaa_3.webp',
      tag: 'BRANDING & DESIGN',
      title: 'Newcomer Music Award Design',
      subtitle: 'From platform design to the design of the awards themselves – we helped sustainably transform the music industry and give young talents the stage they deserve.',
      projectImage: '/img/aaa_2.jpg',
      projectText: 'Visit Platform',
      projectLink: 'https://www.aaartists.com'
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const openProjectLink = (link) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  // Touch event handlers for swipe gestures
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
  };

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6500); // Change slide every 6.5 seconds

    return () => clearInterval(interval);
  }, [currentSlide]);

  // Scroll effect for scaling "SKALIEREN" text
  useEffect(() => {
    let ticking = false;
    let lastScale = scaleValue;
    const gallerySection = document.querySelector('.gallery-slider-section');
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (!gallerySection) {
            ticking = false;
            return;
          }

          const rect = gallerySection.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          
          // Calculate scroll progress when element is in viewport
          // Start scaling when section enters viewport, max scale when centered
          if (rect.top < windowHeight && rect.bottom > 0) {
            // Calculate progress from 0 to 1
            const scrollProgress = Math.max(0, Math.min(1, (windowHeight - rect.top) / windowHeight));
            
            // Scale from 1 to 1.3 (30% increase)
            const newScale = 1 + (scrollProgress * 0.3);
            
            // Only update state if change is significant (reduces re-renders)
            if (Math.abs(newScale - lastScale) > 0.005) {
              setScaleValue(newScale);
              lastScale = newScale;
            }
          }
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial call

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Gallery Slider Header */}
      <div className="gallery-slider-header">
        <div className="gallery-slider-heading-wrapper">
          <h2 className="gallery-slider-heading">
            <span className="gs-heading-monty">BUILD</span>{' '}
            <img src="/img/arrow.svg" alt="arrow" className="gs-arrow-icon" />{' '}
            <span 
              className="gs-heading-montas" 
              style={{ 
                transform: `scale(${scaleValue}) translateZ(0)`
              }}
            >
              SCAAALE
            </span>
          </h2>
          <p className="gallery-slider-description">
          International Clients from Mexico to Spain strengthen their external presence and <span className="gallery-slider-description-highlight">achieve measurably higher revenue</span> – with clear strategy, modern branding, and a proprietary outreach system: BonusClub GOD.
                    </p>
        </div>
        <button 
          className="gallery-slider-button"
          onClick={(e) => {
            e.preventDefault();
            const scaleUpCallSection = document.querySelector('.scaleup-call-wrapper');
            if (scaleUpCallSection) {
              scaleUpCallSection.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
              });
            }
          }}
        >
          Let's talk...
        </button>
      </div>

      <div className="gs-wrapper">
        <div 
          className="gs-container"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
        {/* Background Images - All rendered for smooth crossfade */}
        <div className="gs-background-layer">
          {slides.map((slide, index) => (
            <img 
              key={slide.id}
              src={slide.image} 
              alt={slide.title}
              className={`gs-background-image ${index === currentSlide ? 'active' : ''}`}
            />
          ))}
          <div className="gs-gradient-overlay"></div>
        </div>

        {/* Main Content */}
        <div className="gs-main-content" key={currentSlide}>
          <div className="gs-title-tag">{slides[currentSlide].tag}</div>
          <h1 
            className="gs-big-title"
            dangerouslySetInnerHTML={{ __html: slides[currentSlide].title }}
          />
          <h3 className="gs-title-highlight">
            {slides[currentSlide].subtitle}
          </h3>
        </div>

        {/* Project Info Container - Bottom Right */}
        <div 
          className="gs-project-info" 
          key={`project-${currentSlide}`}
          onClick={() => openProjectLink(slides[currentSlide].projectLink)}
          style={{ cursor: 'pointer' }}
        >
          <div className="gs-project-info-content">
            <p className="gs-project-label">{slides[currentSlide].projectText}</p>
            <div className="gs-project-logo">
              <img src={slides[currentSlide].projectImage} alt={slides[currentSlide].projectText} />
            </div>
          </div>
        </div>

        {/* Slider Controls */}
        <div className="gs-controls">
          <button 
            className="gs-control-btn gs-prev" 
            onClick={prevSlide}
            aria-label="Previous slide"
          >
            <img src="/img/down.svg" alt="Previous" style={{ transform: 'rotate(90deg)', width: '30px', height: '30px', filter: 'brightness(0) invert(1)' }} />
          </button>
          <button 
            className="gs-control-btn gs-next" 
            onClick={nextSlide}
            aria-label="Next slide"
          >
            <img src="/img/down.svg" alt="Next" style={{ transform: 'rotate(-90deg)', width: '30px', height: '30px', filter: 'brightness(0) invert(1)' }} />
          </button>
        </div>

        {/* Slide Indicators */}
        <div className="gs-indicators">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              className={`gs-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default GallerySlider;

